// Small color helpers + deterministic playful palette

function clamp(x) { return Math.max(0, Math.min(255, Math.round(x))); }

function adjust(hex, amt) {
  const n = parseInt(hex.replace("#", ""), 16);
  const r = clamp((n >> 16) + amt);
  const g = clamp(((n >> 8) & 0xff) + amt);
  const b = clamp((n & 0xff) + amt);
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, "0")}`;
}

export const lighten = (hex, amt = 42) => adjust(hex, amt);
export const darken = (hex, amt = 48) => adjust(hex, -amt);

// Keep saved profile colors compatible with the current, green-free visual theme.
export function displayColor(color = "#7C3AED") {
  const legacyColors = { "#10b981": "#7C3AED", "#14b8a6": "#38BDF8", "#34d399": "#A78BFA", "#84cc16": "#FBBF24" };
  return legacyColors[String(color).toLowerCase()] || color || "#7C3AED";
}

export const PALETTE = [
  "#7C3AED", "#3B82F6", "#FB7185", "#FBBF24", "#A855F7",
  "#F97316", "#06B6D4", "#EC4899", "#38BDF8", "#8B5CF6",
];

export function colorFor(key) {
  const s = String(key || "x");
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
}

export const KID_THEMES = {
  // Existing stored keys remain stable when their display palettes change.
  mint:   { label: "Orbit",   bg: "#F5F3FF", blobs: ["#A78BFA", "#FBBF24", "#FB7185"] },
  ocean:  { label: "Ocean",  bg: "#EFF6FF", blobs: ["#3B82F6", "#06B6D4", "#8B5CF6"] },
  candy:  { label: "Candy",  bg: "#FDF2F8", blobs: ["#EC4899", "#FB7185", "#FBBF24"] },
  sunset: { label: "Sunset", bg: "#FFF7ED", blobs: ["#F97316", "#FB7185", "#FBBF24"] },
  grape:  { label: "Grape",  bg: "#F5F3FF", blobs: ["#A855F7", "#8B5CF6", "#EC4899"] },
  jungle: { label: "Daydream", bg: "#FFF7ED", blobs: ["#38BDF8", "#FB7185", "#FBBF24"] },
};

export const REWARD_EMOJIS = [
  "🍦", "🍭", "🍪", "🍕", "🍫", "🧁", "🍿", "🎮", "🕹️", "📺", "📱", "🎬",
  "🎨", "🧸", "⚽", "🚲", "🛴", "🏊", "🎢", "🎡", "🐶", "🐱", "🦄", "🚀",
  "🎁", "💰", "💵", "🌈", "⭐", "🎟️", "🏕️", "🌳", "🎲", "📚", "🎵", "🍩",
];

